export const inputFieldValidator = (value: string, type: string): boolean => {
    // const companyDetailFields = ["name", "companyTypeId", "industryId", "countryId"];
    // const userDetailFields = ["userType", "email"];
    // const productTypeFields = ["code", "catalogName", "fields"];
    // const partnerFields = ["orgnizationName", "orginzationType", "email"];
    // const addProduct = ["code", "sku", "name", "type"];
    // const addProductType = ["code", "catalogName", "fields"];
    // const addRequest = ["invoiceNumber", "billDate", "productItem", "serialNumber"];

    if (type === "array") {
        return value.length === 0;
    } else if (type === "string") {
        return !value || value.trim() === "";
    } else if (type === "email") {
        const trimmed = value?.trim() || "";
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return trimmed === "" || !emailRegex.test(trimmed);
    } else {
        return false;
    }
}